
import { defineComponent, PropType } from 'vue'
import {
  channelMeta,
  formatRelativeTime,
  truncatePreview
} from '@/utils/inboxMessageFormat.js'

interface ProspectRow {
  id: string
  firstName?: string
  lastName?: string
  humanHandoff?: boolean
  aiEnabled?: boolean
  lastMessage?: string | null
  lastMessageAt?: string | null
  messageChannel?: string | null
  socialPlatform?: string | null
  leadScore?: number
  leadGrade?: string
}

export default defineComponent({
  name: 'prospect-conversation-row',
  props: {
    prospect: {
      type: Object as PropType<ProspectRow>,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  emits: ['select'],
  computed: {
    displayName(): string {
      const name = [this.prospect.firstName, this.prospect.lastName]
        .filter(Boolean)
        .join(' ')
        .trim()
      return name || 'Unknown'
    },
    initials(): string {
      const parts = this.displayName.split(/\s+/).filter(Boolean)
      if (!parts.length) {
        return '?'
      }
      return parts.slice(0, 2).map((part) => part.charAt(0).toUpperCase()).join('')
    },
    preview(): string {
      return truncatePreview(this.prospect.lastMessage || '')
    },
    timeLabel(): string {
      return formatRelativeTime(this.prospect.lastMessageAt)
    },
    channel(): { icon: string; color: string; label: string } {
      return channelMeta(this.prospect)
    },
    aiActive(): boolean {
      return !this.prospect.humanHandoff && this.prospect.aiEnabled !== false
    },
    gradeLabel(): string {
      const value = String(this.prospect.leadGrade || 'cold').toLowerCase()
      if (value === 'hot') return 'Hot'
      if (value === 'warm') return 'Warm'
      return 'Cold'
    },
    gradeBadgeClass(): string {
      const value = String(this.prospect.leadGrade || 'cold').toLowerCase()
      if (value === 'hot') return 'badge-light-danger'
      if (value === 'warm') return 'badge-light-warning'
      return 'badge-light-secondary'
    }
  }
})
